import { useTranslation } from 'react-i18next';
import { SelectionBar, ButtonLink } from '@anytag/shared-atoms';
import { SortSelectButtonProps } from '../../schemaTypes';

interface InfluencerSortActionBarTemplateProps {
  selectButtonProps?: SortSelectButtonProps;
}

export const InfluencerSortActionBarTemplate = ({ selectButtonProps }: InfluencerSortActionBarTemplateProps) => {
  const { t } = useTranslation();

  return (
    <SelectionBar
      disabled={selectButtonProps?.disabled}
      className="rounded-b-[inherit] px-3"
      checkboxProps={{
        label: selectButtonProps?.label,
        onClick: selectButtonProps?.onClick,
        disabled: selectButtonProps?.disabled,
        indeterminate: selectButtonProps?.indeterminate
      }}
    >
      <div className="ml-auto flex items-center">
        <ButtonLink
          to="/influencers/proposal"
          title={t('Button.Download & Package')}
          variant="solid"
          className="px-2"
        />
      </div>
    </SelectionBar>
  );
};
